import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

/* api */
import * as DataListAPI from '../../../api/dataList';
import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import DataList from '../../form/DataList';
import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';

function Form({
    token,
    dados,
    setDados,
    //tabelas filhas
    Fabricante,
    setFabricante,
    empresaId,
    empresaIds,
    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    optionsCnhCategoria,
}) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const [OptionsFabricante, setOptionsFabricante] = useState([]);
    const [EnumCombustivel, setCombustivel] = useState({});

    const combustivelTipo = async () => {
        const result = await TabelaAPI.enums('produtoModelos', 'combustivel');
        setCombustivel(result ? result : []);
    };

    // params => empresaId, tabela, id, descricao, condicao, filtro, operacao, funcionarioId
    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };
    useEffect(() => {
        combustivelTipo();
    }, []);
    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name === 'ativo') {
            setDados({ ...dados, [name]: checked });
        } else if (name === 'tanque' || name === 'tara') {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else if (name.startsWith('Fabricante')) {
            setFabricante({
                ...Fabricante,
                [name.split('.')[1]]: value,
            });

            const result = await consultaDatalist({
                empresaId: dados.empresaId,
                tabela: 'Pessoa',
                condicao: 'fabricante',
                filtro: value,
            });
            setOptionsFabricante(result);
            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;

            setDados({
                ...dados,
                fabricanteId: selectedId ?? null,
            });
        } else {
            setDados({ ...dados, [name]: value });
        }
    }

    async function handleOnBlur(e) {
        const { name, value } = e.target;
        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeProdutoModelo(dados.empresaId, dados.fabricanteId, value);

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/produtoModelo/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Modelo de veículo</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />

                <DataList
                    text="Fabricante"
                    title={'Vincula o Fabricante'}
                    name="Fabricante.descricao"
                    inputWidth="450px"
                    filteredOptions={OptionsFabricante}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={Fabricante.descricao || ''}
                />
            </div>
            <div>
                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Modelo"
                    title="Digite o modelo do veículo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required={true}
                    inputWidth="350px"
                />
                <Select
                    name="combustivel"
                    text="Combustível"
                    title="Tipo de combustível"
                    options={EnumCombustivel}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.combustivel}
                    isEnum={true}
                />
                <InputNumber
                    text="Tanque"
                    type="text"
                    name="tanque"
                    placeholder="Litros"
                    inputWidth="100px"
                    title="Capacidade máxima de abastecimento do veículo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.tanque ? formatarNumero(dados.tanque) : ''}
                    required={true}
                />
                <InputNumber
                    text="Lotação"
                    type="text"
                    name="lotacao"
                    inputWidth="100px"
                    title="Capacidade máxima de pessoas no veículo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.lotacao}
                />
                <InputNumber
                    text="Eixos"
                    type="text"
                    name="eixos"
                    inputWidth="100px"
                    title="quantidade de eixos do veículo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.eixos}
                />
                <InputNumber
                    text="Potência"
                    type="text"
                    name="potencia"
                    inputWidth="100px"
                    title="Potência do veículo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.potencia}
                />
                <InputNumber
                    text="Tara"
                    type="text"
                    name="tara"
                    inputWidth="100px"
                    title="é o peso do veículo vazio, sem carga, passageiros ou motorista, mas incluindo componentes fixos como chassi, motor, carroceria, fluidos (combustível, óleo) e equipamentos obrigatórios (como estepe)"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.tara ? formatarNumero(dados.tara) : ''}
                />
                <Select
                    title="Selecione a categoria da cnh exigida para conduzir o veículo"
                    text="CNH"
                    name="cnhCategoriaId"
                    inputWidth="80px"
                    options={optionsCnhCategoria}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.cnhCategoriaId || ''}
                    notOptNull={false}
                />
                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
